var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.436,
    height: 58.415,
    viewBox: "0 0 58.436 58.415",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M140.034,121.6c-.043,4.486-.054,7.634-.113,10.767a42.171,42.171,0,0,1-.387,5.668,15.371,15.371,0,0,1-12.3,13.4,30.015,30.015,0,0,1-5.6.593c-6.2.2-12.394.121-18.593.083-1.908-.012-3.817-.1-5.725-.243A17.639,17.639,0,0,1,89.5,149.57a14.774,14.774,0,0,1-6.69-8.385,21.794,21.794,0,0,1-.989-5.427c-.272-4.315-.215-8.635-.217-12.953q0-4.66.075-9.322a40.131,40.131,0,0,1,.389-5.642,16.3,16.3,0,0,1,3.673-8.393,15.28,15.28,0,0,1,8.008-4.842,25.9,25.9,0,0,1,5.083-.694c3.952-.2,7.909-.165,11.865-.174q4.894,0,9.79.082a38.323,38.323,0,0,1,5.421.383,16.521,16.521,0,0,1,7.98,3.326,15.206,15.206,0,0,1,5.258,8.359,22.838,22.838,0,0,1,.684,5.031C139.919,114.933,139.984,118.941,140.034,121.6Zm-53.122,1.324H86.8c.069,3.817.13,7.646.217,11.469a18.945,18.945,0,0,0,.638,4.663,9.771,9.771,0,0,0,4.025,5.678,11.273,11.273,0,0,0,5.232,1.785c1.62.173,3.253.272,4.882.295,6.856.09,13.706.173,20.567-.09a19.094,19.094,0,0,0,4.511-.633,9.736,9.736,0,0,0,6.214-4.911,13.041,13.041,0,0,0,1.388-5.264c.115-1.735.2-3.491.212-5.236.047-6.676.174-13.359-.154-20.024a16.313,16.313,0,0,0-.793-4.434,9.5,9.5,0,0,0-4.728-5.59,12.66,12.66,0,0,0-5.245-1.364c-2.049-.121-4.1-.22-6.15-.229-6.1-.028-12.2-.128-18.294.125a18.915,18.915,0,0,0-5.227.829,9.662,9.662,0,0,0-4.993,3.7,11.524,11.524,0,0,0-1.844,5.031,40.274,40.274,0,0,0-.338,5.522C86.886,117.135,86.912,120.029,86.912,122.921Z",
    transform: "translate(-81.598 -93.74)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M193.476,190.648A14.993,14.993,0,1,1,178.5,175.66,14.993,14.993,0,0,1,193.476,190.648Zm-15.217,9.735a9.732,9.732,0,1,0-9.505-9.977A9.738,9.738,0,0,0,178.259,200.382Z",
    transform: "translate(-149.283 -161.448)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M326.576,155.544a3.508,3.508,0,1,1-3.5-3.5A3.508,3.508,0,0,1,326.576,155.544Z",
    transform: "translate(-278.276 -141.926)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.193fedfefee9b09e544743d081df3148.svg";
export { ForwardRef as ReactComponent };